import React, { useEffect, useMemo, useState } from "react";
import { useTable, useSortBy } from "react-table";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import PaginationAndSearching from "../../Pagination Component/paginationAndSearching";
import SkeletonTableRow from "../../SkeltonTable/skeletonTable";
import { useDispatch, useSelector } from "react-redux";
import {
  formatDate,
  currencyFormat,
  formatDateTime,
} from "../../../../function/commonFunction";
import { Button, Checkbox, FormControlLabel, List, ListItem, ListItemText, Menu, MenuItem } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import ExpiryDateFilter from "../../../pages/propertyList/ExpiryDateFilter";
import { findSubMenuByName } from "../../../pages/propertyList/MenuUtlis";
import { getApprovalMatrix } from "../../../../service/invoice/getApprovalMatrix";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Collapse,
  Paper,
} from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";

export const PendingForApprovalInvoiceTable = ({
  column,
  rowsArr,
  handleActionPending,
  handleSearchPagination,
  searchValuePagination,
  pageSizePagination,
  handleChangeRowsPerPagePagination,
  totalCountPagination,
  handleOnChangePagination,
  showLoading,
  totalCount,
  handleActionMultipleApprove,
  onLoadData,
  fromDate,
  toDate,
  setFromDate,
  setToDate,
  tab,
  setPageSizePending,
  setFilterType,
  PFAShowAll,
  handlePFACheckboxChange
}) => {
  const { permissionArr } = useSelector((state) => state.auth);
  const { permissions } = useSelector((state) => state.permissionsData);

  const dispatch = useDispatch();

  const columns = useMemo(() => column, [column]);
  const data = useMemo(() => rowsArr, [rowsArr]);
  const [checkedRows, setCheckedRows] = useState([]);
  const [isAllChecked, setIsAllChecked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const tableInstance = useTable({ columns, data }, useSortBy);
  const [expandedRowIndex, setExpandedRowIndex] = useState(null);
  const [expandedRowIndexForAM, setExpandedRowIndexForAM] = useState(null);
  const [labels, setLabels] = useState([]);
  const [approvalMatrixData, setApprovalMatrixData] = useState({}); // Store approval matrix data per row
  const [auditDisplay, setAuditDisplay] = useState(false); // Modal visibility state
  const [selectedApprovalMatrixData, setSelectedApprovalMatrixData] =
    useState(null); // Data to be displayed in modal

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    tableInstance;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  
  const [totalAmount, setTotalAmount] = useState(0);

  const handleCheckboxChange = (row) => {
    setCheckedRows((prev) => {
      let updatedCheckedRows;
      if (prev.includes(row.id)) {
        updatedCheckedRows = prev.filter((id) => id !== row.id);
      } else {
        updatedCheckedRows = [...prev, row.id];
      }
  
      // Calculate total amount for selected rows
      const selectedTotal = rows
        .filter((r) => updatedCheckedRows.includes(r.id))
        .reduce((sum, r) => sum + (r.original.TotalAmount || 0), 0); // Ensure TotalAmount exists
  
      setTotalAmount(selectedTotal);
      return updatedCheckedRows;
    });
  };
  
  const handleHeaderCheckboxChange = () => {
    setIsAllChecked((prev) => !prev);
    if (!isAllChecked) {
      // Select only rows where CanApprove is true
      const approvedRows = rows.filter((row) => row.original.CanApprove);
      const approvedRowIds = approvedRows.map((row) => row.id);
  
      setCheckedRows(approvedRowIds);
  
      // Calculate total TotalAmount for approved rows
      const selectedTotal = approvedRows.reduce((sum, row) => sum + (row.original.TotalAmount || 0), 0);
      setTotalAmount(selectedTotal);
    } else {
      // Deselect all rows
      setCheckedRows([]);
      setTotalAmount(0);
    }
  };

  // const handleCheckboxChange = (row) => {
  //   setCheckedRows((prev) => {
  //     if (prev.includes(row.id)) {
  //       return prev.filter((id) => id !== row.id);
  //     } else {
  //       return [...prev, row.id];
  //     }
  //   });
  // };

  useEffect(() => {
    if (tab !== "Pending for Approval") {
      setCheckedRows([]);
    }
    if (checkedRows.length === 0) {
      setIsAllChecked(false);
    }
  }, [checkedRows, tab]);

  // const handleHeaderCheckboxChange = () => {
  //   setIsAllChecked((prev) => !prev);
  //   if (!isAllChecked) {
  //     setCheckedRows(rows.map((row) => row.id));
  //   } else {
  //     setCheckedRows([]);
  //   }
  // };

  // const handleHeaderCheckboxChange = () => {
  //   setIsAllChecked((prev) => !prev);
  //   if (!isAllChecked) {
  //     // Only collect IDs of rows where CanApprove is true
  //     const approvedRowIds = rows
  //       .filter((row) => row.original.CanApprove)
  //       .map((row) => row.id);
  //     setCheckedRows(approvedRowIds);
  //   } else {
  //     // Deselect all rows
  //     setCheckedRows([]);
  //   }
  // };
  const getCheckedRows = () => {
    return rows
      .filter((row) => checkedRows.includes(row.id))
      .map((row) => row.original);
  };

  const getApprovalMatrixApiCall = (index, data) => {
    dispatch(
      getApprovalMatrix(
        data?.Id,
        (response) => {
          setSelectedApprovalMatrixData(response?.data?.result);
          setAuditDisplay(true); // Show the modal
        },
        (error) => {
        }
      )
    );
  };

  const toggleRowExpansionForAM = (index) => {
    setExpandedRowIndexForAM((prevIndex) => (prevIndex === index ? null : index));
  };

  const toggleRowExpansion = (index, expandedRowData) => {
    setExpandedRowIndex((prevIndex) => (prevIndex === index ? null : index));
    const labels = [
      { key: "Location Address", value: expandedRowData.SupplierAddress },
      { key: "Remarks", value: expandedRowData.Remark },
      {
        key: "Invoice Due Date",
        value: formatDate(expandedRowData.InvoiceDueDate),
      },
      {
        key: "Tax Amount",
        value: currencyFormat(expandedRowData.TotalTaxValue),
      },
    ];

    // Add "Amount" label only if InvoiceType is not "Telephone"
    if (!expandedRowData.InvoiceType.includes("Telephone")) {
      labels.push({
        key: "Bill Amount",
        value: currencyFormat(expandedRowData.Amount),
      });
    }
    if (expandedRowData.InvoiceType.includes("Telephone")) {
      labels.push({ key: "Circle", value: expandedRowData.Circle });
      labels.push({ key: "Account Number", value: expandedRowData.AccountNo });
      labels.push({
        key: "Location Address",
        value: expandedRowData.LocationAddress,
      });
    }
    const filteredLabels = labels.filter((label) => label.value !== null);

    setLabels(filteredLabels);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  // Helper function to check if a specific action exists in a submenu
  const hasAction = (submenu, actionName) =>
    submenu?.Actions.includes(actionName);

  // Find the "Invoice" menu
  const propertiesMenu = findSubMenuByName(permissions, "Invoice");
  const listPropertyMenu = propertiesMenu
    ? findSubMenuByName(propertiesMenu?.SubMenus, "Invoice List")
    : null;
  const approvedSubMenu = listPropertyMenu
    ? findSubMenuByName(listPropertyMenu?.SubMenus, "Pending for Approval")
    : null;
  // Check actions in the "New" submenu
  const canApprove = approvedSubMenu
    ? hasAction(approvedSubMenu, "Approve")
    : false;
  const canSearch = approvedSubMenu
    ? hasAction(approvedSubMenu, "Search")
    : false;
  const canMoreFilter = approvedSubMenu
    ? hasAction(approvedSubMenu, "MoreFilter")
    : false;
  const canAudittrial = approvedSubMenu
    ? hasAction(approvedSubMenu, "Audittrial")
    : false;
  const canEdit = approvedSubMenu ? hasAction(approvedSubMenu, "Edit") : false;
  const canReject = approvedSubMenu
    ? hasAction(approvedSubMenu, "Reject")
    : false;
  const canAssignUsers = approvedSubMenu
    ? hasAction(approvedSubMenu, "AssignUsers")
    : false;
  const canViewUsers = approvedSubMenu
    ? hasAction(approvedSubMenu, "ViewUsers")
    : false;
  const canViewVendors = approvedSubMenu
    ? hasAction(approvedSubMenu, "ViewVendors")
    : false;
  const MoreFilterSubMenu = approvedSubMenu
    ? findSubMenuByName(approvedSubMenu?.SubMenus, "MoreFilters")
    : null;
  const invoiceType = MoreFilterSubMenu
    ? hasAction(MoreFilterSubMenu, "InvoiceType")
    : false;
  const expiryDate = MoreFilterSubMenu
    ? hasAction(MoreFilterSubMenu, "ExpiryDate")
    : false;
    const showAllInvoices = approvedSubMenu
    ? hasAction(approvedSubMenu, "ShowAllInvoices")
    : false;
  const handlePageSizeChange = (event) => {
    setPageSizePending(event.target.value);
  };

  const [type, setTpe] = React.useState(permissionArr.some(role => /(telephone|admin)/i.test(role))?'Telephone':"Maintenance/Electricity");
  const handleChange = (event) => {
    setTpe(event.target.value);
  };

  // Memoize whether any row has CanApprove set to true
  const hasRowsWithCanApprove = useMemo(
    () => data.some((row) => row.CanApprove),
    [data]
  );
  useEffect(() => {
    setTpe(permissionArr.some(role => /(telephone|admin)/i.test(role))?'Telephone':"Maintenance/Electricity")
  setFilterType(permissionArr.some(role => /(telephone|admin)/i.test(role))?'Telephone':"Maintenance/Electricity")
  }, [tab])
  
  useEffect(() => {
    setFilterType(type);
  }, [type]);
  return (
    <>
      <div className="card">
        <div className="card-header">
          {canApprove && (
            <button
              className="btn btn-success dz-xs-flex m-r5"
              style={{ background: "rgba(233, 133, 35, 0.84)", border: "none" }}
              disabled={isLoading || getCheckedRows().length === 0}
              onClick={() => {
                const values = getCheckedRows();

                const idsArray = values.map((invoice) => ({
                  InvoiceId: invoice.Id,
                  FileId: invoice.FileId,
                }));

                handleActionMultipleApprove(idsArray);
                setCheckedRows([]);
                setIsAllChecked(false);
              }}
            >
              {isLoading ? " Approving " : " Approve Invoices"}
            </button>
          )}
        </div>
        <div className="card-body">
     <div style={{display:'flex',justifyContent:'space-between'}}>
     <h4 style={{marginTop:"10px",marginRight:'10px'}}>Total Invoices : &nbsp; {totalCount}</h4>
     <div className="d-flex justify-content-end">
          {checkedRows?.length!==0? (
  <div style={{display:'flex',marginTop:'12px',marginRight:'10px'}}>
       <h5 style={{marginRight:'10px'}}>Selected Invoices : {checkedRows?.length}</h5>
       <h5>Total Amount : {currencyFormat(totalAmount)}</h5>
  </div>
):null}
{showAllInvoices ? (
  <>
    {type === "Telephone" && (
      <div>
        <FormControlLabel
          sx={{ marginBottom: "-10px", marginTop: "2px" }}
          control={
            <Checkbox checked={PFAShowAll} onChange={handlePFACheckboxChange} />
          }
          label="Show all pending invoices"
        />
      </div>
    )}
  </>
) : null}
            {canSearch && (
              <div
                className="service-input-group input-group"
                style={{ width: "220px" }}
              >
                <span className="input-group-text search-input-icon">
                  <i className="bi bi-search" style={{ fontSize: "16px" }}></i>
                </span>
                <input
                  type="text"
                  className="form-control search-input"
                  id="val-username1"
                  placeholder="Search..."
                  name="username"
                  value={searchValuePagination}
                  onChange={handleSearchPagination}
                />
              </div>
            )}
            {MoreFilterSubMenu && (
              <Button
                id="demo-positioned-button"
                aria-controls={open ? "demo-positioned-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={handleClick}
                sx={{
                  textTransform: "none",
                }}
              >
                More Filters<span class="material-icons">arrow_drop_down</span>
              </Button>
            )}
            <ExpiryDateFilter
              onLoadData={() =>{ 
                onLoadData("InvoiceList", type)
                setTotalAmount(0)
                setCheckedRows([]);
                handleClose()
              }}
              open={open}
              fromDate={fromDate}
              toDate={toDate}
              setFromDate={setFromDate}
              anchorEl={anchorEl}
              handleClose={handleClose}
              setToDate={setToDate}
              type={type}
              handleChange={handleChange}
              showInvoiceType={invoiceType}
              showExpDate={expiryDate}
              //  setTpe={setTpe}
            />
          </div>
     </div>
          <br />
          {canApprove &&
                          hasRowsWithCanApprove && (
                            <h5 style={{marginRight:'10px',cursor:'pointer'}} onClick={handleHeaderCheckboxChange}> Select All </h5>
                          )}
          <div className="table-responsive">
            <div className="dataTables_wrapper">
              <table {...getTableProps()} className="table dataTable display">
                <thead>
                  {headerGroups.map((headerGroup) => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column, index) => (
                        <th
                          {...column.getHeaderProps(
                            column.getSortByToggleProps()
                          )}
                          style={{
                            color: "rgba(23, 90, 169, 0.78)",
                            width: "0px",
                            padding: "5px 0px",
                            }}
                        >
                          {canApprove &&
                          hasRowsWithCanApprove &&
                          index === 0 ? (
                            <input
                              style={{margin:'5px'}}
                              type="checkbox"
                              checked={isAllChecked}
                              onChange={handleHeaderCheckboxChange}
                            />
                          ) : (
                            <>
                              {column.render("Header")}
                              {index !== 0 && (
                                <span className="ml-1">
                                  {column.isSorted ? (
                                    column.isSortedDesc ? (
                                      <i
                                        className="fa fa-arrow-down ms-2 fs-14"
                                        style={{ opacity: "0.7" }}
                                      />
                                    ) : (
                                      <i
                                        className="fa fa-arrow-up ms-2 fs-14"
                                        style={{ opacity: "0.7" }}
                                      />
                                    )
                                  ) : (
                                    <i
                                      className="fa fa-sort ms-2 fs-14"
                                      style={{ opacity: "0.3" }}
                                    />
                                  )}
                                </span>
                              )}
                            </>
                          )}
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>

                <tbody {...getTableBodyProps()}>
                  {rows.map((row, rowIndex) => {
                    prepareRow(row);
                    const isRowExpanded = expandedRowIndex === rowIndex;
                    const rowData = row?.original; // This represents the full row data

                    return (
                      <>
                        <tr
                          {...row.getRowProps()}
                          style={{
                            background: !isRowExpanded
                              ? rows[rowIndex].original.IsExpired
                                ? "rgb(255 0 0 / 20%) "
                                : "white"
                              : rows[rowIndex].original.IsExpired
                              ? "rgb(255 0 0 / 20%) "
                              : "#d3d3d3a8",
                            padding: "5px 0px",
                            margin: 0,
                          }}
                        >
                          {row.cells.map((cell, cellIndex) => {
                            const multipleSelect = cellIndex === 0;
                            const SupplierName = cellIndex === 1;

                            const InoiceNumber = cellIndex === 2;
                            const InvoiceType = cellIndex === 3;
                            const InvoiceDate = cellIndex === 4;
                            const TotalAmountVal = cellIndex === 5;
                            const LocationCode = cellIndex === 6;
                            const isLastColumn =
                              cellIndex === row.cells.length - 1;

                            const shouldHideInvoiceType =
                              cell.column.accessor === "InvoiceType" &&
                              permissionArr.some((permission) =>
                                permission.includes("Telephone")
                              );

                            return (
                              <td
                                {...cell.getCellProps()}
                                style={{
                                  color: "black",
                                  whiteSpace: "normal",
                                  padding: "5px 0px",
                                  margin: 0,
                                }}
                              >
                                {isLastColumn ? (
                                  <div style={{width:'100px'}}>
                                    {canEdit && (
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={
                                          <Tooltip id="tooltip">
                                            {"edit"}
                                          </Tooltip>
                                        }
                                      >
                                        <i
                                          className="material-icons"
                                          style={{
                                            color: "rgba(233, 133, 35, 0.84)",
                                            marginRight: "6px",
                                            cursor: "pointer",
                                            width: "18px",
                                            height: "18px",
                                          }}
                                          onClick={() => {
                                            handleActionPending(
                                              rows[rowIndex].original.Id,
                                              "edit",
                                              rows[rowIndex].original,
                                              ""
                                            );
                                          }}
                                        >
                                          edit
                                        </i>
                                      </OverlayTrigger>
                                    )}
                                    {canAudittrial && (
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={
                                          <Tooltip id="tooltip">
                                            {"Audit"}
                                          </Tooltip>
                                        }
                                      >
                                        <i
                                          className="material-icons"
                                          style={{
                                            color: "rgba(23, 90, 169, 0.78)",
                                            marginRight: "6px",
                                            cursor: "pointer",
                                            width: "18px",
                                            height: "18px",
                                          }}
                                          onClick={() => {
                                            handleActionPending(
                                              rows[rowIndex].original.Id,
                                              "audit",
                                              rows[rowIndex].original
                                            );
                                          }}
                                        >
                                          history
                                        </i>
                                      </OverlayTrigger>
                                    )}
                                    {canReject && (
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={
                                          <Tooltip id="tooltip">
                                            {"Reject"}
                                          </Tooltip>
                                        }
                                      >
                                        <i
                                          className="material-icons"
                                          style={{
                                            color: "red",
                                            marginRight: "6px",
                                            cursor: "pointer",
                                            width: "18px",
                                            height: "18px",
                                          }}
                                          onClick={() => {
                                            handleActionPending(
                                              rows[rowIndex].original.Id,
                                              "cancel",
                                              rows[rowIndex].original
                                            );
                                          }}
                                        >
                                          block
                                        </i>
                                      </OverlayTrigger>
                                    )}
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={
                                        <Tooltip id="tooltip">
                                          {"Expand"}
                                        </Tooltip>
                                      }
                                    >
                                      <i
                                        className="material-icons"
                                        style={{
                                          cursor: "pointer",
                                          marginRight: "6px",
                                          width: "18px",
                                          height: "18px",
                                        }}
                                        onClick={() => {
                                          toggleRowExpansion(
                                            rowIndex,
                                            rows[rowIndex].original
                                          );
                                        }}
                                      >
                                        {isRowExpanded ? "remove" : "add"}
                                      </i>
                                    </OverlayTrigger>
                                    {/* {!rowData?.CanApprove && (
                                                <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">{"Approval Matrix"}</Tooltip>}>
                                                <i
                                                  className="material-icons"
                                                  style={{ cursor: "pointer" ,
                                                    color: "green",
                                                    width:'17px',height:'19px'
                                                  }}
                                                  onClick={() => {
                                                    getApprovalMatrixApiCall(rowIndex,rows[rowIndex].original)
                                                   
                                                    // toggleRowExpansion(rowIndex,rows[rowIndex].original)
                                                  }}
                                                >
                                                 published_with_changes
                                                </i>
                                              </OverlayTrigger>
                                    )} */}
                                  </div>
                                ) : canApprove && multipleSelect ? (
                                  // This part is for individual checkboxes
                                  rowData.CanApprove ? (
                                    <input
                                    style={{margin:'5px'}}
                                      type="checkbox"
                                      checked={checkedRows.includes(row.id)}
                                      onChange={() => handleCheckboxChange(row)}
                                    />
                                  ) : (
                                    // Displaying Approval Matrix icon if CanApprove is false
                                    <OverlayTrigger
                                      placement="top"
                                      overlay={
                                        <Tooltip id="tooltip">
                                          {"Approval Matrix"}
                                        </Tooltip>
                                      }
                                    >
                                      <i
                                        className="material-icons"
                                        style={{
                                          cursor: "pointer",
                                          color: "green",
                                          width: "17px",
                                          height: "19px",
                                        }}
                                        onClick={() =>
                                          getApprovalMatrixApiCall(
                                            rowIndex,
                                            rowData
                                          )
                                        }
                                      >
                                        published_with_changes
                                      </i>
                                    </OverlayTrigger>
                                  )
                                ) : ( 
                                  (cell.column.id === "SupplierName" &&
                                    cell.render("Cell")) ||
                                  (cell.column.id === "InvoiceNo" &&
                                    cell.render("Cell")) ||
                                  (!shouldHideInvoiceType &&
                                    cell.column.id === "InvoiceType" &&
                                    cell.render("Cell")) ||
                                  (cell.column.id === "InvoiceDate" &&
                                    formatDate(
                                      rows[rowIndex].original.InvoiceDate
                                    )) ||
                                  (cell.column.id === "TotalAmount" &&
                                    currencyFormat(
                                      rows[rowIndex].original.TotalAmount
                                    )) ||
                                      (cell.column.id === "CurrentMonthTotalPayableCharges" &&
                                     (
                                      <>
                                      <div style={{textAlign:'center'}}>
                                        {currencyFormat(
                                          rows[rowIndex].original.CurrentMonthTotalPayableCharges
                                        )}
                                      </div>
                                      </>
                                     )
                                      ) ||
                                  (cell.column.id === "LocationCode" &&
                                    cell.render("Cell")) ||
                                  cell.render("Cell")
                                )}
                              </td>
                            );
                          })}
                        </tr>

                        {isRowExpanded && (
                          <tr>
                            <td colSpan={headerGroups[0].headers.length}>
                              <div
                                className="expanded-content"
                                style={{
                                  backgroundColor: "lightgrey",
                                  padding: "10px",
                                  borderRadius: "5px",
                                }}
                              >
                                {/* <h5>Expanded Data</h5> */}

                                {labels.map((label, index) => (
                                  <div className="row">
                                    <div className="col-3  d-flex flex-column">
                                      <label
                                        key={index}
                                        style={{
                                          whiteSpace: "normal",
                                          fontWeight: "600",
                                          color: "black",
                                        }}
                                      >
                                        {label.key}
                                      </label>
                                    </div>
                                    <div className="col-9 d-flex flex-column">
                                      <label
                                        key={index}
                                        style={{
                                          whiteSpace: "normal",
                                          color: "black",
                                        }}
                                      >
                                        {label.value}
                                      </label>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </td>
                          </tr>
                        )}
                        <Modal
                          size="lg"
                          className="fade bd-example-modal-lg"
                          show={auditDisplay}
                          centered
                          aria-labelledby="example-modal-sizes-title-lg"
                        >
                          <Modal.Header>
                            <Modal.Title id="example-modal-sizes-title-lg">
                              Approval Matrix
                            </Modal.Title>
                            <Button
                              onClick={() => setAuditDisplay(false)} // Close modal
                              variant="xl"
                              className="btn-close"
                            ></Button>
                          </Modal.Header>
                          <Modal.Body>
                            {selectedApprovalMatrixData ? (
                              <TableContainer>
                                <Table>
                                  <TableHead>
                                    <TableRow>
                                      <TableCell>Role</TableCell>
                                      <TableCell>Status</TableCell>
                                      <TableCell>Users</TableCell>
                                      {/* <TableCell>No Of Approvals</TableCell>
              <TableCell>Completed Approvals</TableCell>
              <TableCell>Remaining Approvals</TableCell> */}
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {selectedApprovalMatrixData?.map(
                                      (item, index) => (
                                                          <React.Fragment key={index}>
                                        <TableRow>
                                          <TableCell>{item.Role}</TableCell>
                                          <TableCell>{item.Status}</TableCell>
                                           <TableCell>
                                                                      <IconButton
                                                                        onClick={() => toggleRowExpansionForAM(index)}
                                                                      >
                                                                        {expandedRowIndexForAM === index ? (
                                                                          <KeyboardArrowUp />
                                                                        ) : (
                                                                          <KeyboardArrowDown />
                                                                        )}
                                                                      </IconButton>
                                                                </TableCell>
                                        </TableRow>
                                        {expandedRowIndexForAM === index && (
                      <TableRow>
                        <TableCell colSpan={4}>
                          <Collapse
                            in={expandedRowIndexForAM === index}
                            timeout="auto"
                            unmountOnExit
                          >
<List sx={{ backgroundColor: "rgba(128, 128, 128, 0.4)", borderRadius: "8px", padding: "8px" }}>
{item?.Users && item?.Users.length > 0 ? (
    item.Users.map((user, idx) => (
      <ListItem key={idx}>
        <ListItemText primary={`${idx + 1}. ${user}`} />
      </ListItem>
    ))
  ) : (
    <ListItem>
      <ListItemText primary="No users available" />
    </ListItem>
  )}
</List>
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    )}
                                        </React.Fragment>
                                      )
                                    )}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            ) : (
                              <p>No approval matrix data available</p>
                            )}
                          </Modal.Body>
                          <Modal.Footer></Modal.Footer>
                        </Modal>
                      </>
                    );
                  })}
                </tbody>
                {showLoading && <SkeletonTableRow cols={6} row={6} />}
              </table>
              {rows.length === 0 && (
                <div style={{ display: "flex", justifyContent: "center" }}>
                  No record found
                </div>
              )}
            </div>
          </div>
          {/* Pagination & Page Size */}
          <div className="pagination-container d-flex justify-content-between">
            <div style={{ marginTop: "20px" }}>
              <label htmlFor="pageSizeSelect">Rows per page: </label>
              <select
                id="pageSizeSelect"
                value={pageSizePagination}
                onChange={handlePageSizeChange}
                style={{ marginLeft: "10px" }}
              >
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
                <option value={250}>250</option>
                <option value={500}>500</option>
              </select>
            </div>
            <PaginationAndSearching
              handleSearch={handleSearchPagination}
              searchValue={searchValuePagination}
              defaultValue={pageSizePagination}
              handleChangeRowsPerPage={handleChangeRowsPerPagePagination}
              totalCount={totalCountPagination}
              onChange={(e, p) => {
                handleOnChangePagination(e, p);
                setCheckedRows([]);
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default PendingForApprovalInvoiceTable;
